import { render } from "./PostQualificationThanks.html?vue&type=template&id=0dec6a03&ts=true&external"
import script from "./PostQualificationThanks.vue?vue&type=script&lang=ts"
export * from "./PostQualificationThanks.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__